import { Identifiable } from '@mews/std';

export const getId = <Item extends Identifiable>(item: Item) => item.id;
